import React, { Component } from 'react';
import { ResponsiveContainer, Legend, Bar, BarChart, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { connect } from "react-redux";
import {
    getHasAboonemangeByAfid, 
    getHasOrderVardeByAfid,
    getOrderVardeListByAfid,setofUpdatedashboard,onGetDashBoardValueOf,
} from 'actions'
import {isEmpty} from 'lodash'
import {NumberFormat} from 'components/NotyNumberFormat'
import IntlMessages from 'util/IntlMessages';

const mapStateToProps = ({ auth,DashBoard,accountsData }) => {
    const { authUser} = auth;
    const { updatedashboard,DashBoardValueOf} = accountsData
    const { OrderVardeList,AfidHasAbon,AfidHasOrderVarde,DashboardOrderFilterOption} = DashBoard;
    return { authUser,OrderVardeList,AfidHasAbon,AfidHasOrderVarde,DashboardOrderFilterOption,updatedashboard,DashBoardValueOf };
};
function mapDispatchToProps(dispatch) {
    return {
        getHasAboonemangeByAfid: (Afid) => dispatch(getHasAboonemangeByAfid(Afid)),
        getHasOrderVardeByAfid: (Afid) => dispatch(getHasOrderVardeByAfid(Afid)),
        getOrderVardeListByAfid: (Afid,userid,FilterOption) => dispatch(getOrderVardeListByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
        onGetDashBoardValueOf: (Afid,userid) => dispatch(onGetDashBoardValueOf(Afid,userid)),
        dispatch
    };
}

const data = [
    { name: "JAN", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "FEB", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "MAR", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "APR", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "MAJ", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "JUN", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "JUL", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "AUG", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "SEP", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "OKT", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "NOV", "TB": 0, "Lopande": 0, "OrderVarde": 0 },
    { name: "DEC", "TB": 0, "Lopande": 0, "OrderVarde": 0 }
];

const renderColorfulLegendText = (value, entry) => {
    const { color } = entry;
    
    return <span style={{ color }}>{formatNumber(value)}</span>;
  }

const formatNumber=(number)=>{
    return `${(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`
    // return `${(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} `
}
class Diagram extends Component {
    state={
        OrderVardeList:data,
        DashboardOrderFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
      }
    intervalID = null

    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
    }
    componentDidMount=()=>{
        
        const Afid = this.props.Afid
        this.props.getHasAboonemangeByAfid(Afid)
        this.props.getHasOrderVardeByAfid(Afid)
        this.props.onGetDashBoardValueOf(Afid,undefined)
        this.props.getOrderVardeListByAfid(Afid,undefined,this.state.DashboardOrderFilterOption)
        .then(() => {
            this.initiateInterval() 
            this.setState({done: true})   
        })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){            
                    this.setState({done: false})
              const Afid = this.props.Afid;
              this.props.getOrderVardeListByAfid(Afid,undefined,this.state.DashboardOrderFilterOption)
              .then(() => {
                this.initiateInterval() 
                this.setState({done: true})   
            })
        }
            },
            180000
        );
    }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboard) === 1){
            this.props.getOrderVardeListByAfid(Afid,undefined,this.state.DashboardOrderFilterOption)
            .then(() => {
              this.initiateInterval() 
              this.setState({done: true})   
          })
            this.props.setofUpdatedashboard()
        }
       
    }
    getDashBoardValueOf = ()=>{
        try{
        let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 4)
        if(ModuleValue.Value > 2 && ModuleValue.Value !== 5){
            return 2
        }else{
            return 1
        }
    }
    catch(error){return 1}
    }
    getDashBoardValueOf2 = ()=>{
        try{
        let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 4)
       // console.log(ModuleValue,"test545553")
        if(ModuleValue.isUpdated === 0){
            return 0
        }else{
            return ModuleValue.Value
        }
    }
    catch(error){return 0}
    }
    formatNumbers=(number)=>{
        const _ValueOF = this.getDashBoardValueOf()
        return NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
      //return NumberFormat(number, 'compact', 'auto', 0)
        
      }
      formatNumbers22=(number)=>{
        const _ValueOF = this.getDashBoardValueOf()
        return NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
        //return NumberFormat(number, 'compact', 'auto', 1)
    }
    render() {
        const _ValueOF = this.getDashBoardValueOf2()
        return (
        <div className="d-flex justify-content-start">
            <ResponsiveContainer width="97%" height={this.props.heightValue > 1 ? this.props.heightValue : 330}>
                <BarChart
                    data={this.props.OrderVardeList}
                    margin={{ top: 0, right: 0, left: this.props.Flags?.DashboardRoundoff === 0 ? 50 : 10, bottom: 0 }}
                    barCategoryGap={5}
                >
                    <XAxis stroke="#ffffff66" tick={{ fill: 'white' }} dataKey="name" />
                    <YAxis stroke="#ffffff66" tick={{ fill: 'white' }} type="number"  tickFormatter={tick => {
              return this.formatNumbers22(tick)
            }} />
                    {/* <CartesianGrid strokeDasharray="0" stroke="#44D1C24D" /> */}
                    {/* <CartesianGrid strokeDasharray="0" stroke="#0c969c" /> */}
                    <Tooltip 
                        // position={{ y: -50, x: -30 }}
                        cursor={{ stroke: '#12585E', strokeWidth: 1, fill: "#12585E" }} 
                        content={<CustomTooltip ValueOF={_ValueOF} {...this.props}/>}
                    />
                    <Legend formatter={renderColorfulLegendText} iconType="circle" />

                    <Bar
                        dataKey="TB"
                        name={parseInt(_ValueOF) === 0?this.props.Flags.ValueInNotyfile === 0?"TB":parseInt(this.props.Flags.ValueInNotyfile) === 1?"Utpris":"Antal":
                            parseInt(_ValueOF) === 1?"TB":parseInt(_ValueOF) === 2?"Utpris":"Antal"}
                        fill="#7793F5"
                        radius={[30, 30, 0, 0]}
                        stackId="a"
                        // background={{ fill: '#0E898F40', radius: 30, }}
                        barSize={15}
                        // fill="#054447"
                    />

                    {
                        parseInt(this.props.AfidHasAbon) === 1?
                        <Bar
                        dataKey="Lopande"
                        name={"Löpande"}
                        fill="#C377E0"
                        radius={[30, 30, 0, 0]}
                        // background={{ fill: '#0E898F40', radius: 30, }}
                        barSize={15}
                        // fill="#075a5f"
                        />
                        :""
                    }
                    {
                        parseInt(this.props.AfidHasOrderVarde) === 1?
                        <Bar
                        dataKey="OrderVarde"
                        name={"Ordervärde"}
                        fill="#44D1C2"
                        radius={[30, 30, 0, 0]}
                        // background={{ fill: '#0E898F40', radius: 30, }}
                        barSize={15}
                        // fill="#097177"
                        />
                        :""
                    }                    
                    
                </BarChart>
            </ResponsiveContainer >
        </div >
    );
}
};

function CustomTooltip (props) {
    // console.log('test54555', props.payload)
    const formatNumbers2=(number)=>{
        if(props.ValueOF >2){
            return NumberFormat(number, 'total', 'default', 0)
          } else{
            return NumberFormat(number, props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', 'auto', 0)
          } 
    }
    // let month = props.payload.payload.name
    
    if(isEmpty(props.payload)) return ''
    return (
        // console.log('test54555', props.payload)
    <div className="bg-white p-2 shadow-sm rounded" 
    style={{ marginLeft: props.payload[0].payload.name === 'NOV' ||
                         props.payload[0].payload.name === 'DEC'
                         ? '0rem' : '2rem' ,
            marginRight: props.payload[0].payload.name === 'NOV' ||
                         props.payload[0].payload.name === 'DEC'
                         ? '2.5rem' : '0rem' 
    }}
    >
        <p style={{textAlign: 'center'}}>{props.payload[0].payload.name}</p>
        <>
        <p style={{color: '#637ACC', textAlign: 'left'}}>{`${
            props.ValueOF === 0?props.Flags.ValueInNotyfile === 0?"TB":parseInt(props.Flags.ValueInNotyfile) === 1?"Utpris":"Antal":
            props.ValueOF === 1?"TB":
            props.ValueOF === 2?"Utpris":"Antal"
        }: ${formatNumbers2(props.payload[0].payload.TB)}`}</p>
        <p style={{color: '#855199', textAlign: 'left'}}><IntlMessages id="Input.onGoing"/>{`: ${formatNumbers2(props.payload[0].payload.Lopande)}`}</p>
        <p style={{color: '#32998E ', textAlign: 'left'}}>{`Ordervärde: ${formatNumbers2(props.payload[0].payload.OrderVarde)}`}</p>
        </> 
    </div>
    )
  }

export default connect(mapStateToProps,mapDispatchToProps)(Diagram);
